require('../scss/index.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('../scss/utils/bootstrap/bootstrap.min.css');

require('animate.css/animate.min.css');

var $ = require('jquery');
var common = require('./common');
var lang ='';
var allHonorsObj = {
    zh: [
        {
            time: '2025年',
            content:  ['最佳财务顾问活跃榜单','TOP 1'],
            origin: '企名片'
        },
        {
            time: '2025年',
            content:  ['人工智能领域财务顾问','TOP 1'],
            origin: '企名片'
        },
        {
            time: '2025年',
            content:  ['新能源领域财务顾问','TOP 1'],
            origin: '企名片'
        },
        {
            time: '2025年H1',
            content:  ['退出先锋','私募投资机构TOP 10'],
            origin: '钛媒体'
        },
        {
            time: '2025年H1',
            content: ['FA（融资）先锋', 'TOP 1'],
            origin: '钛媒体'
        },
        {
            time: '2024',
            content: ['年度A类','基金管理人'],
            origin: '中国保险资管业协会'
        },
        {
            time: '2024',
            content: ['一级市场活跃FA机构','第一名'],
            origin: 'IT桔子'
        },
        {
            time: '2024',
            content: ['年度最佳','并购交易服务投行'],
            origin: 'IPO早知道'
        },
        {
            time: '2024',
            content: ['最佳客户体验奖','华兴证券'],
            origin: '财联社'
        },
        {
            time: '2024',
            content: ['最佳ETF生态奖', '华兴证券'],
            origin: '财联社'
        },
        {
            time: '2024',
            content: ['最佳成长财富管理奖','华兴证券'],
            origin: '财联社'
        },
        {
            time: '2024',
            content: ['中国证券业','量化资管计划君鼎奖', '华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券业','权益类资管计划君鼎奖','华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券业','新锐财富经纪商君鼎奖','华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券业','零售经济商君鼎奖','华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券报','证券业金牛奖','华兴证券'],
            origin: '中国证券报'
        },
        {
            time: '2024',
            content: ['年度IPO','最佳投资机构TOP 50'],
            origin: 'IPO早知道'
        },
    ],
    trzh: [
        {
            time: '2025年',
            content:  ['最佳财务顾问活跃榜单','TOP 1'],
            origin: '企名片'
        },
        {
            time: '2025年',
            content:  ['人工智能领域财务顾问','TOP 1'],
            origin: '企名片'
        },
        {
            time: '2025年',
            content:  ['新能源领域财务顾问','TOP 1'],
            origin: '企名片'
        },
        {
            time: '2025年H1',
            content:  ['退出先锋','私募投资机构TOP 10'],
            origin: '钛媒体'
        },
        {
            time: '2025年H1',
            content: ['FA（融资）先锋', 'TOP 1'],
            origin: '钛媒体'
        },
        {
            time: '2024',
            content: ['年度A类','基金管理人'],
            origin: '中国保险资管业协会'
        },
        {
            time: '2024',
            content: ['一级市场活跃FA机构','第一名'],
            origin: 'IT桔子'
        },
        {
            time: '2024',
            content: ['年度最佳','并购交易服务投行'],
            origin: 'IPO早知道'
        },
        {
            time: '2024',
            content: ['最佳客户体验奖','华兴证券'],
            origin: '财联社'
        },
        {
            time: '2024',
            content: ['最佳ETF生态奖', '华兴证券'],
            origin: '财联社'
        },
        {
            time: '2024',
            content: ['最佳成长财富管理奖','华兴证券'],
            origin: '财联社'
        },
        {
            time: '2024',
            content: ['中国证券业','量化资管计划君鼎奖', '华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券业','权益类资管计划君鼎奖','华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券业','新锐财富经纪商君鼎奖','华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券业','零售经济商君鼎奖','华兴证券'],
            origin: '证券时报'
        },
        {
            time: '2024',
            content: ['中国证券报','证券业金牛奖','华兴证券'],
            origin: '中国证券报'
        },
        {
            time: '2024',
            content: ['年度IPO','最佳投资机构TOP 50'],
            origin: 'IPO早知道'
        },
    ],
    en: [
        {
            time: '2025',
            content: ['The Most Active', 'Financial Advisor', 'TOP1'],
            origin: 'QIMINGPIAN'
        },
        {
            time: '2025',
            content: ['Leading Financial Advisor', 'in AI Sector', 'TOP1'],
            origin: 'QIMINGPIAN'
        },
        {
            time: '2025',
            content: ['Leading Financial Advisor', 'in New Energy Sector', 'TOP1'],
            origin: 'QIMINGPIAN'
        },
        {
            time: 'H1 2025',
            content: ['Exit  Pioneers -', 'Top 10 Private', 'Investment Institutions'],
            origin: 'TMT POST'
        },
        {
            time: 'H1 2025',
            content: ['Top 1', 'Financing Advisor Pioneer'],
            origin: 'TMT POST'
        },
        {
            time: '2024',
            content: ['Class A', 'Fund Manager'],
            origin: 'Insurance Asset Management Association of China'
        },
        {
            time: '2024',
            content: ['Top 1', 'Most Active FA Institution', 'in Primary Market'],
            origin: 'ITJUZI'
        },
        {
            time: '2024',
            content: ['Best M&A Advisory', 'Investment Bank'],
            origin: 'IPO ZAOZHIDAO'
        },

        {
            time: '2024',
            content: ['Best Customer', 'Experience Award', 'CR Securities'],
            origin: 'CLS'
        },
        {
            time: '2024',
            content: ['Best ETF', 'Ecosystem Award', 'CR Securities'],
            origin: 'CLS'
        },
        {
            time: '2024',
            content: ['Best Growth Wealth', 'Management Award', 'CR Securities'],
            origin: 'CLS'
        },
        {
            time: '2024',
            content: ['Excellence Award', 'for Quantitative Asset', 'Management Plans', 'CR Securities'],
            origin: 'Securities Times'
        },
        {
            time: '2024',
            content: ['Excellence Award', 'for Equity Asset', 'Management Plans', 'CR Securities'],
            origin: 'Securities Times'
        },

        {
            time: '2024',
            content: ['Rising Star Wealth', 'Broker Award', 'CR Securities'],
            origin: 'Securities Times'
        },
        {
            time: '2024',
            content: ['Excellence Award', 'for Retail Brokers', 'CR Securities'],
            origin: 'Securities Times'
        },
        {
            time: '2024',
            content: ['Golden Bull Award', 'for Securities Industry', 'CR Securities'],
            origin: 'China Securities Journal'
        },
        {
            time: '2024',
            content: ['Top 50', 'IPO Investment Institutions'],
            origin: 'IPO ZAOZHIDAO'
        },
    ]
}
//var icon = require('../img/favicon.jpg');
//console.log(icon);
//alert('hello world');

$( document ).ready(function() {
    lang =common.initChangePage();

    var animateClass ='fadeInUp animated';


    if(lang === 'zh'){
        $('.logo').removeClass('logo-zh').addClass('logo-zh2');
        $('.honor-tit-inner').removeClass('honor-tit-inner-en')
    }else{
        $('.logo').removeClass('logo-en').addClass('logo-en2');
        $('.honor-tit-inner').addClass('honor-tit-inner-en');
        
    }


    $('.carousel-box').height($(window).height());


    $('.img-hover').hover(function(){
       

        var hover = $(this).find('.hover');

        hover.show();
        hover.addClass(animateClass);

    },function(){
        var hover = $(this).find('.hover');
        hover.hide();
        hover.removeClass(animateClass);
    })

    $('.culture').hover(function(){
        $(this).removeClass('cuNoHover').addClass('active');
        $(this).find('.text').show();
        $(this).find('.text').addClass(animateClass);
    },function(){
        $(this).removeClass('active').addClass('cuNoHover');
        $(this).find('.text').hide();
        $(this).find('.text').removeClass(animateClass);
    })



    var decadeHeight = $('.decade-box .right').height();
    $('.decade-box .left').height(decadeHeight);


    var $root = $('html, body');
    $('.arrowA').click(function() {
        var href = $.attr(this, 'href');
        $root.animate({
            scrollTop: $(href).offset().top
        }, 500, function () {
            window.location.hash = href;
        });
        return false;
    });




    $('.video-img').click(function(){
        $(this).hide();
        $('#video')[0].play();
    })
    
    var huaxingHonors = allHonorsObj[lang];

    var innerStr = getInnerStr(huaxingHonors.length, 5);
    $('.honors-inner').html(innerStr);
    setHonors(0);

    //初始 inner
    function getInnerStr(page, pageSize) {

        var count = Math.ceil(page / pageSize);
        var str = '';
        for(var i = 0; i < count; i++) {
            if(i == 0) {
                str += '<div class="item active" index=' + i + '></div>';
            } else if(i > 0 && i < 6) {
                str += '<div class="item" index=' + i + '></div>';
            }
        }
        return str;
    }
    //页面数据渲染
    function setHonors(index) {
        index = parseInt(index);
        var str = '';
        var size = '';
        var startHtml = lang === 'en' ? '<div class="col-md-1-5 col-honor col-honor-en">' : '<div class="col-md-1-5 col-honor">';
        var extraStartHtml = lang === 'en' ? '<div class="col-md-1-5 col-honor col-honor-extra col-honor-en">' : '<div class="col-md-1-5 col-honor col-honor-extra">';

        var topLeftTag = lang === 'en' ? '<div class="en-honor-top">' : '<div class="zh-honor-top">';
        var topRightTag = lang === 'en' ?  '</div>' : '</div>';
        var bottomLeftTag =  lang === 'en' ? '<div class="en-honor-bottom">' : '<div class="zh-honor-bottom">';
        var bottomRightTag =  lang === 'en' ?  '</div>' : '</div>';

        if((index + 1) * 5 > huaxingHonors.length) {
            size = huaxingHonors.length;
        } else if(index == 0) {
            size = 5;
        } else {
            size = index * 5 + 5;
        }

        if(lang === 'en') {
            for(var y = index * 5; y < size; y++) {
                var huaxingHonorsObj = huaxingHonors[y];
                str += startHtml +
                            '<div class="col-honor-wrap">' + 
                                topLeftTag +
                                '<div class="time">' + huaxingHonorsObj.time + '</div>' +
                                '<div class="en-content-wrap">' +
                                    huaxingHonorsObj.content.map(str => '<div class="content">' + str +  '</div>').join('')  +
                                '</div>' +
                                topRightTag +
                                bottomLeftTag +
                                '<div class="text-line"></div>' + 
                                '<div class="origin">' + huaxingHonorsObj.origin + '</div>' +
                                bottomRightTag +
                            '</div>' + 
                        '</div>'
            }
            if((index + 1) * 5 >= huaxingHonors.length) {
                str += extraStartHtml +
                    '<div class="col-honor-wrap col-honor-wrap-extra">' + 
                        '<div class="dots">' +
                            '<div class="dot"></div>' +
                            '<div class="dot"></div>' +
                            '<div class="dot"></div>' +
                            '<div class="dot"></div>' +
                        '</div>' +
                    '</div>' + 
                '</div>'
            }
        } else {
            // eslint-disable-next-line no-redeclare
            for(var y = index * 5; y < size; y++) {
                // eslint-disable-next-line no-redeclare
                var huaxingHonorsObj = huaxingHonors[y];
                str += startHtml +
                            '<div class="col-honor-wrap">' +
                                topLeftTag + 
                                    '<div class="time">' + huaxingHonorsObj.time + '</div>' +
                                    '<div class="zh-content-wrap">' +
                                        huaxingHonorsObj.content.map(str => '<div class="content">' + str +  '</div>').join('')  +
                                    '</div>' +
                                topRightTag +
                                bottomLeftTag +
                                    '<div class="text-line"></div>' + 
                                    '<div class="origin">' + huaxingHonorsObj.origin + '</div>' +
                                bottomRightTag +
                            '</div>' + 
                 
                            '</div>'
            }
            if((index + 1) * 5 >= huaxingHonors.length) {
                str += extraStartHtml +
                    '<div class="col-honor-wrap col-honor-wrap-extra">' + 
                        '<div class="dots">' +
                            '<div class="dot"></div>' +
                            '<div class="dot"></div>' +
                            '<div class="dot"></div>' +
                            '<div class="dot"></div>' +
                        '</div>' +
                    '</div>' + 
                '</div>'
            }
        }

        

        $('.row-honors').html(str);
        

        //翻页点击
        $('.item').click(function() {
            var index = $(this).attr('index');
            $(this).parents('.inner').find('.active').removeClass('active');
            $(this).addClass('active');
            setHonors(index);
        });
    }


});



// WEBPACK FOOTER //
// ./src/index.js